// extracted by mini-css-extract-plugin
module.exports = {"avatar":"styles_avatar__30M6_","img":"styles_img__3_gZC"};